import { defineComponent, computed } from "vue";
import { useAccountStore } from "src/stores/account";
import { useViewStore } from 'src/stores/view';
import { layoutIntPlugin } from "src/plugins/i18n/local/layouts";
import standardAvatar from "src/components/image/standardAvatar.vue";
import standardOptionsList from "src/layouts/standard/components/navOptions/standardOptionsList.vue";
/**
 * Value for mobile options
 */
export default defineComponent({
    name: "drawer-options",
    components: {
        standardAvatar,
        standardOptionsList,
    },
    emits: ["close"],
    setup() {
        const { t } = layoutIntPlugin();
        const accountStore = useAccountStore();
        const user = computed(() => accountStore.user);
        const userMisc = computed(() => accountStore.userMisc);
        const userAccDeletion = computed(() => {
            if (!userMisc.value)
                return null;
            return userMisc.value?.ac_marked_for_deletion || null;
        });
        const viewStore = useViewStore();
        /**
         * Verify account
         */
        function verify() {
            viewStore.toggleVerifier(true, true, 'email_verifier');
        }
        return {
            t,
            user,
            userMisc,
            userAccDeletion,
            verify,
        };
    },
});
